export const PRIMARY_DOMAIN = "https://www.katkin.com";
export const PAGE_TITLE_SUFFIX = "";
export const DEFAULT_PAGE_TITLE = `For healthy cats ${PAGE_TITLE_SUFFIX}`;
export const DEFAULT_PAGE_DESCRIPTION = "We design a personalised, fresh and perfectly portioned meal plan for every cat, using their age, weight, activity level and current body shape. We ensure every cat gets the right amount of nutrients and daily calories, just for them"; // This will change
export const DEFAULT_OG_IMAGE = `${PRIMARY_DOMAIN}/images/sharing/opengraph.png`;
export const TRUST_PILOT_REVIEWS_URL = "https://www.trustpilot.com/review/katkin.club";
